var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hub drawers"},[_c('CreateTaskDrawer'),_c('ProjectBriefingDrawer'),_c('CreateProjectDrawer'),_c('CreateContractDrawer'),_c('CreateCampaignDrawer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }